const routes = {
  '/dashboard': 'Bảng tổng hợp thông tin',
  '/admin-db': 'Truy cập trực tiếp database',
  '/field-master-data': 'Field Master Data',
  '/email-sender': 'Email đại diện gửi notification',
  '/report-issue': 'Báo lỗi cho lập trình viên',
  '/docs': 'Các tài liệu của hệ thống Houselink',
  '/upload-file': 'Upload file lên server Houselink',

  '/users/list': 'Danh sách  Người dùng',
  '/users/import': 'Tạo thêm Người dùng',

  '/contractors/list-approved': 'Danh sách Nhà thầu đã xác thực',
  '/contractors/list-not-approved': 'Danh sách Nhà thầu chưa xác thực',
  '/contractors/list-not-approved-update': 'Danh sách Nhà thầu chưa xác thực update',
  '/contractors/import': 'Tạo thêm Nhà thầu',

  '/projects/list-approved': 'Danh sách Dự án đã xác thực',
  '/projects/list-not-approved': 'Danh sách Dự án chưa xác thực',
  '/projects/list-not-approved-update': 'Danh sách Dự án chưa xác thực qua update',
  '/projects/import': 'Tạo thêm Dự án',
  '/project/:id': 'Chi tiết dự án',

  '/bidding/list-approved': 'Danh sách hạng mục đấu thầu đã duyệt',
  '/bidding/list-not-approved': 'Danh sách hạng mục đấu thầu chưa được duyệt',
  '/bidding/list-not-approved-update': 'Danh sách hạng mục đấu thầu chưa được duyệt update',
  '/bidding/:id': 'Chi tiết bidding',

  '/products/list': 'Danh sách Sản phẩm',
  '/products/import': 'Tạo thêm Sản phẩm',

  '/user/:id': 'Chi tiết Người dùng',

  '/contacts/list': 'Danh sách Liên hệ',
  '/contacts/import': 'Nhập contact',

  '/orders/completed': 'Danh sách Orders đã xong',
  '/orders/waiting': 'Danh sách Orders đang chờ thanh toán',
  '/orders/canceled': 'Danh sách Orders đã hủy',
  '/orders/failed-to-charge': 'Danh sách Orders bị lỗi thanh toán',
  '/orders/in-process': 'Danh sách Orders đang tiến hành',
  '/orders/shipped': 'Danh sách Orders đã ship',

  '/order/:id': 'Chi tiết đơn hàng',
};
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js